import { create } from 'zustand'
import api from '../services/api'

// Drives the numeric badge on the Learning rail icon (PrimarySidebar):
// "how many courses haven't I closed yet" on the active server. Mirrors
// the lean mandatoryLearningStore, but hits /learning/me/overview (ALL
// visible courses + my status, not just mandatory) and counts the ones
// without a completedAt. PrimarySidebar calls refresh() on navigation, so
// finishing a course clears the badge without a reload. Fail soft to 0 —
// a learning-module/API blip must never disturb the rail.
interface LearningBadgeState {
  /** Visible courses on the active server with no completion yet. */
  incompleteCount: number
  refresh: (serverId: string | undefined) => Promise<void>
}

export const useLearningBadgeStore = create<LearningBadgeState>((set) => ({
  incompleteCount: 0,
  refresh: async (serverId) => {
    if (!serverId) return
    try {
      const { data } = await api.get('/learning/me/overview', { params: { serverId } })
      const count = Array.isArray(data)
        ? data.filter((c: { completedAt?: string | null }) => !c?.completedAt).length
        : 0
      set({ incompleteCount: count })
    } catch {
      set({ incompleteCount: 0 })
    }
  },
}))
